import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table,Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";
import Select from "react-select";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const TransportationUniform = () => {
  const [filters, setFilters] = useState({
    school_id: "",
    class_id: "",
  });
const [showAssignModal, setShowAssignModal] = useState(false);

const [shgList, setShgList] = useState([]);
const [memberList, setMemberList] = useState([]);

const today = new Date().toISOString().split("T")[0];

const [assignData, setAssignData] = useState({
  shg_id: "",
  member_ids: [],
  issue_date: today
});
  const [loading, setLoading] = useState(false);
//   const today = new Date().toISOString().split("T")[0]; // "YY
  const [schoolList, setSchoolList] = useState([]);
  const [sectionlList, setSectionList] = useState([]);

  const [classList, setClassList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [transportationList, setTransportationList] = useState([]);
  const [transportationListItemWise, setTransportationListItemWise] = useState([]);

  const loadShgList = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      {
        vendor_type_id: "3"   // SHG
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.data.status === true) {
      setShgList(res.data.data || []);
    } else {
      setShgList([]);
    }

  } catch (err) {
    handle401(err);
  }
};

  const allSelected =
    transportationList.length > 0 && selectedIds.length === transportationList.length;

  const fetchIssueTransportData = async () => {
const token = localStorage.getItem("token");

    if (!filters.school_id) return;

    try {
      setLoading(true);

      const response = await axios.post(
        `${BASE_URL}/getDataForTransportation`,
        {
          school_id: filters.school_id,
        //   class_id: filters.class_id || "",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.data.status === true) {
         const students = response.data.data[0].student_wise || [];

  setTransportationList(students);
  setTransportationListItemWise(response.data.data.item_size_summary || []);

  // ✅ auto select all students
  const allIds = students.map((s) => s.student_id);
  setSelectedIds(allIds);
      } else {
        setTransportationList([]);
        setTransportationListItemWise([]);
      }
    } catch (err) {
      handle401(err);
    } finally {
      setLoading(false);
    }
  };

  const loadSchools = async () => {
    try {
  const token = localStorage.getItem("token");
      const municipality_id = localStorage.getItem("municipality_id");

      let payload = {};

      payload = {
        municipality_id: municipality_id,
      };

      const res = await axios.post(`${BASE_URL}/schoolList`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSchoolList(res.data.data || []);
    } catch (err) {
      handle401(err);
    }
  };

  const loadClasses = async () => {
    try {
  const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClassList(res.data.data.class_list || []);
    } catch (err) {
      handle401(err);
    }
  };

  const fetchSectionList = async() =>{
      try{
      const token = localStorage.getItem("token");
          const response = await axios.get(`${BASE_URL}/sectionList`,

          { headers: { Authorization: `Bearer ${token}` } }
      )

      if(response.data.status === true){
          setSectionList(response.data.data.sectionList || []);
      }
      else{
          console.log("error sectionlist");
      }

      }catch(err){
         console.error("Student count error", err);
        if (handle401(err)) return;
      }
    }



const handleTransportation = async () => {

  if (selectedIds.length === 0) {
    Swal.fire("Warning", "Please select at least one student", "warning");
    return;
  }

  if (!assignData.issue_date) {
  Swal.fire("Warning", "Please select Issue Date", "warning");
  return;
}

  const confirmResult = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to assign transportation for selected students?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Assign",
    cancelButtonText: "Cancel",
  });

  if (!confirmResult.isConfirmed) return;

  const token = localStorage.getItem("token");

  // ✅ build assignData array
  const assignList = transportationList
    .filter((student) => selectedIds.includes(student.student_id))
    .map((student) => ({
      student_id: student.student_id,
      measurement_ids: student.items?.map(i => i.measurement_id) || [],
      item_ids: student.items?.map(i => i.item_id) || [],
      quantities: student.items?.map(i => i.quantity) || [],
    }));

  const body = {
    issue_date: assignData.issue_date,
    school_id: filters.school_id,
    vendor_id: assignData.shg_id,
    member_ids: assignData.member_ids,
    assignData: assignList
  };


try {
  setLoading(true);

  const response = await axios.post(
    `${BASE_URL}/doAssignTransport`,
    body,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (response.data.status === true) {
    Swal.fire("Success", response.data.message, "success");

    setSelectedIds([]);
    setAssignData({
      shg_id: "",
      member_ids: [],
      issue_date: today
    });

    fetchIssueTransportData();
  } else {
    // ✅ show backend message directly
    Swal.fire({
      icon: "error",
      title: "Alert",
      text: response.data.message
    });
  }

} catch (error) {

  handle401(error);

  // ✅ show backend validation message
  Swal.fire({
    icon: "error",
    title: "Alert",
    text: error?.response?.data?.message || "Something went wrong"
  });

} finally {
  setLoading(false);
}
};

const loadMembers = async (shgId) => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/memberList`,
      {
        shg_id: shgId
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.data.status === true) {
      setMemberList(res.data.data || []);
    } else {
      setMemberList([]);
    }

  } catch (err) {
    handle401(err);
  }
};

  useEffect(() => {
    loadSchools();
    loadClasses();
    fetchSectionList();
    loadShgList();
  }, []);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ================= FILTER CARD ================= */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> Transportation
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  School <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={filters.school_id}
                  onChange={(e) =>
                    setFilters({ ...filters, school_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select School</option>

                  {schoolList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  Class (Optional)
                </Form.Label>
                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({ ...filters, class_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select Class</option>

                  {classList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col> */}

            {/* <Col md={3}>
                              <Form.Group className="mb-3">
                                <Form.Label className="fw-semibold text-black">
                                  Section <span className="text-danger">*</span>
                                </Form.Label>

                                 <Form.Select
style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                                >
                                  <option value="">Select Section</option>

                                  {sectionlList.map((sec) => (
                                    <option key={sec.id} value={sec.id}>
                                      {sec.section_name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col> */}

              <Col md={2} className="mt-3">
                <Button
                  className="w-100 fw-semibold text-white"
                  style={{ background: "#1565C1", borderRadius: "10px" }}
                  onClick={() => {
                    if (!filters.school_id) {
                      Swal.fire(
                        "Alert",
                        "Please select atleast one School",
                        "warning",
                      );
                      return;
                    }
                    fetchIssueTransportData()
                  }}
                >
                  <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                </Button>
              </Col>

              {/* Reset Button */}
              <Col md={2} className="mt-3">
                <Button
                  className="w-100 fw-semibold text-white"
                  style={{ background: "#E53935", borderRadius: "10px" }}
                  onClick={() => {
                    setFilters({
                      school_id: "",
                      class_id: "",
                    });

                    setTransportationList([]);
                    setTransportationListItemWise([]);
                    setSelectedIds([]);
                  }}
                >
                  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                </Button>
              </Col>

          </Row>
        </Card.Body>
      </Card>

      <div className="mt-3">


        <Row>
          {transportationListItemWise.map((item, index) => (
            <Col md={2} key={index} className="mb-3">
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                  background: "linear-gradient(135deg, #42A5F5, #1E88E5)",
                  borderRadius: "50px",
                  boxShadow: "0 4px 12px rgba(30,136,229,0.35)",
                  color: "#fff",
                }}
              >
                <div style={{ lineHeight: "1.2" }}>
                  <div style={{ fontSize: "16px", fontWeight: "600" }}>
                    {item.item_name}
                  </div>
                  <div style={{ fontSize: "16px", opacity: 0.9 }}>
                    Size: {item.size}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {item.total_quantity}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>


            <Row className="align-items-end">
  <Col md={2}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">
        SHG <span className="text-danger">*</span>
      </Form.Label>

      <Form.Select
        value={assignData.shg_id}
        onChange={(e) => {
          const shgId = e.target.value;
setAssignData({
  ...assignData,
  shg_id: shgId,
  member_ids: []
});          loadMembers(shgId);
        }}
        style={{
                borderRadius: "10px",
                border: "2px solid #1565C1",
                }}
      >
        <option value="">Select SHG</option>
        {shgList.map((shg) => (
          <option key={shg.id} value={shg.id}>
            {shg.vendors_master_name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>

  <Col md={3}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">
        Member <span className="text-danger">*</span>
      </Form.Label>

      {/* <Form.Select
        value={assignData.member_id}
        disabled={!assignData.shg_id}
        onChange={(e) =>
          setAssignData({ ...assignData, member_id: e.target.value })
        }
        style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
      >
        <option value="">Select Member</option>
        {memberList.map((mem) => (
          <option key={mem.user_id} value={mem.user_id}>
            {mem.name}
          </option>
        ))}
      </Form.Select> */}

     <Select
  isMulti
  isDisabled={!assignData.shg_id}

  options={memberList.map((mem) => ({
    value: mem.user_id,
    label: mem.name
  }))}

  styles={{
    control: (base) => ({
      ...base,
      borderRadius: "10px",
      border: "2px solid #1565C1",
      minHeight: "38px",
      boxShadow: "none"
    })
  }}

  value={memberList
    .filter((mem) => assignData.member_ids.includes(mem.user_id))
    .map((mem) => ({
      value: mem.user_id,
      label: mem.name
    }))
  }

  onChange={(selected) =>
    setAssignData({
      ...assignData,
      member_ids: selected.map((s) => s.value)
    })
  }
/>
    </Form.Group>
  </Col>


  <Col md={2}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">
        Issue Date <span className="text-danger">*</span>
      </Form.Label>

      <Form.Control
  type="date"
  value={assignData.issue_date}
  onChange={(e) =>
    setAssignData({ ...assignData, issue_date: e.target.value })
  }
  style={{
    borderRadius: "10px",
    border: "2px solid #1565C1",
  }}
/>


    </Form.Group>
  </Col>

  <Col md={6}>
    <Button
      variant="success"
      style={{ width: "370px" }}
      disabled={selectedIds.length === 0}
      onClick={handleTransportation}
      className="text-white mb-3"
    >
      <i className="fa-solid fa-truck me-2"></i>
      Assign Transportation / Delivery
    </Button>
  </Col>
</Row>


      {/* ================= TABLE ================= */}




      {loading && (
        <div className="loader-wrapper">
          <div className="blue-spinner"></div>

          <div className="loading-line">
            <div className="loading-progress"></div>
          </div>

          <p className="loading-text">Loading, please wait...</p>
        </div>
      )}
      {!loading && (
        <Card
          className="mb-4 border-0 mt-2"
          style={{
            background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
            boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          }}
        >
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th
                  style={{
                    width: "130px",
                    minWidth: "50px",
                    maxWidth: "130px",
                    padding: "4px",
                    backgroundColor: "#edf7fe",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    //   label="All"
                    checked={allSelected}
                    onChange={(e) => {
                      if (e.target.checked) {
                        const allIds = transportationList.map((row) => row.student_id);
                        setSelectedIds(allIds);
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                    style={{ margin: 0 }}
                  />
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  SL
                </th>

                {/* <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  School
                </th> */}

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Class
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Section
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Roll no
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Gender
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Items
                </th>
              </tr>
            </thead>
            <tbody>
              {!loading && transportationList.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}

              {transportationList.map((row, index) => (
                <tr key={row.student_id}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={selectedIds.includes(row.student_id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds((prev) => [...prev, row.student_id]);
                        } else {
                          setSelectedIds((prev) =>
                            prev.filter((id) => id !== row.student_id),
                          );
                        }
                      }}
                    />
                  </td>
                  <td className="text-center">{index + 1}</td>
                  {/* <td className="text-center">{row.school_name}</td> */}
                  <td className="text-center">{row.class_name}</td>
                  <td className="text-center">{row.section_name}</td>
                  <td className="text-center">{row.roll_no}</td>
                  <td className="text-center">{row.gender}</td>
                  <td className="text-center">
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                      {row.items?.map((item, i) => (
                        <span
                          key={i}
                          style={{
                            background:
                              "linear-gradient(135deg, #42A5F5, #1E88E5)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.item_name} ({item.size}) × {item.quantity}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>




        </Card>
      )}
    </div>
  );
};

export default TransportationUniform;
